<template>
    <main-content with_go_back_bar>
        <gateway-filter :action="filterAction" ></gateway-filter>
        <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
    </main-content>
</template>

<script>

import mainContent from "@/components/main-content";
import {StarShopApiUrl} from "@/common/api.service";
import {AuthorizationHeader} from "@/common/jwt.service";
import columns from "./datatable/gateways-columns";
import toastr from "toastr";
import store from '@/store'
import {mapGetters} from "vuex";
import GatewayFilter from "./components/gateway-filter.vue";

export default {
    name: "user_category_details",
    components: {
        GatewayFilter,
        'main-content': mainContent,
    },
    data() {
        return {
            cat_id: this.$route.params.hashid,
            query: {}
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "dedicated_categories_datatable",
                data: {
                    type: "remote",
                    source: {
                        read: {
                            url: StarShopApiUrl.path("dedicated/admin/categories/" + this.$route.params.hashid + '/members'),
                            method: "GET",
                            headers: AuthorizationHeader,
                            map: function (res) {
                                return res.data.data;
                            },
                            params: {
                                query: this.query,
                            },
                            success: function (res) {
                                store.commit('dedicated/categorizedDedicateds', res.data.data)
                            },
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {},
                pagination: false,
                sortable: true,
                columns: columns,
            };
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: true,
                rtl: false
            }

            return toastr
        },
        ...mapGetters('user', [
            'status'
        ])
    },
    methods: {
        filterAction(e, query) {
            this.query = query;
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload();
            }
        }
    }
}
</script>